import Signup from "../../components/@signup/members/Signup";

import { routeTypes } from "../../hooks/useSystemRoutes";

export default function SignupPage() {

    return (
        <Signup 
            routeType={routeTypes.member}
        />
    )
}       